import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Care = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M17.122 26.9944L6.35767 21.2511V8.10659L17.122 2.48169L27.3178 8.10659V21.2511L17.122 26.9944Z"
        fill="#F655DD"
      />
      <path
        d="M6.35767 8.10659L17.122 13.7315M6.35767 8.10659V21.2511L17.122 26.9944M6.35767 8.10659L17.122 2.48169L27.3178 8.10659M17.122 13.7315V26.9944M17.122 13.7315L27.3178 8.10659M17.122 26.9944L27.3178 21.2511V8.10659"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1492 21.6846C16.9183 23.6701 17.132 26.7154 16.5166 29.6635L8.83212 29.6635L4.164 17.3594L3.9962 10.4231C4.23818 8.31153 6.67863 8.48427 6.85999 10.3235C6.85999 10.3235 7.47901 15.7633 8.1499 17.424C8.28579 16.2231 9.99574 16.1614 10.708 16.8412C12.8976 18.9308 13.38 19.6991 15.1492 21.6846Z"
        fill="#FFDB59"
      />
      <path
        d="M8.1499 17.424C8.28579 16.2231 9.99574 16.1614 10.708 16.8412C12.8976 18.9308 13.38 19.6991 15.1492 21.6846C16.9183 23.6701 17.132 26.7154 16.5166 29.6635L8.83212 29.6635L4.164 17.3594L3.9962 10.4231C4.23818 8.31153 6.67863 8.48427 6.85999 10.3235C6.85999 10.3235 7.47901 15.7633 8.1499 17.424ZM8.1499 17.424L11.6357 23.4504"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M18.8098 21.6846C17.0407 23.6701 16.827 26.7154 17.4424 29.6635L25.1269 29.6635L29.795 17.3594L29.9628 10.4231C29.7208 8.31153 27.2804 8.48427 27.099 10.3235C27.099 10.3235 26.48 15.7633 25.8091 17.424C25.6732 16.2231 23.9632 16.1614 23.251 16.8412C21.0614 18.9308 20.5789 19.6991 18.8098 21.6846Z"
        fill="#FFDB59"
      />
      <path
        d="M25.8091 17.424C25.6732 16.2231 23.9632 16.1614 23.251 16.8412C21.0614 18.9308 20.5789 19.6991 18.8098 21.6846C17.0407 23.6701 16.827 26.7154 17.4424 29.6635L25.1269 29.6635L29.795 17.3594L29.9628 10.4231C29.7208 8.31153 27.2804 8.48427 27.099 10.3235C27.099 10.3235 26.48 15.7633 25.8091 17.424ZM25.8091 17.424L22.4482 23.2004"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  )
})

export default Care
